/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Promise_TitleInputs */

const en_mk_promise_title = /** @type {(inputs: Mk_Promise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI that shows up already built, already knows your company, and is safe by default.`)
};

const id_mk_promise_title = /** @type {(inputs: Mk_Promise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI yang datang sudah jadi, kenal perusahaanmu, dan aman.`)
};

/**
* | output |
* | --- |
* | "AI that shows up already built, already knows your company, and is safe by default." |
*
* @param {Mk_Promise_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_promise_title = /** @type {((inputs?: Mk_Promise_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Promise_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_promise_title(inputs)
	return en_mk_promise_title(inputs)
});